import { styled } from '@/stitches.config';

export const DropdownListStyled = styled('ul', {
  textAlign: 'left',
  minWidth: '128px',
  backgroundColor: '$white',
  position: 'absolute',
  boxShadow: '$menu',
  borderRadius: '$3',
  listStyleType: 'none',
  margin: '$0',
  py: '$3',
  px: '$0',
  zIndex: '$dropdown',
});

export const DropdownListItemStyled = styled('li', {
  px: '$3',
  py: '$2',
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: '$coolGray300',
  },
  '&.selected': {
    fontWeight: '$medium',
  },
});
